import { inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, of, switchMap, takeUntil, throwError } from 'rxjs';

const AUTH_ENDPOINT =
  /\/corporate-client\/(?:v2\/)?(?:login|register|refresh|resend-otp|auth|password\/forgot)(?:\/|$)/;

export const AuthInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  if (
    request.headers.has('Authorization') ||
    AUTH_ENDPOINT.test(request.url.split('?')[0])
  ) {
    return next(request);
  }

  const token = authService.getToken();
  if (!token?.token) return next(request);
  const authorizedRequest = (accessToken: string) =>
    request.clone({
      setHeaders: { Authorization: `Bearer ${accessToken}` },
    });

  return next(authorizedRequest(token.token)).pipe(
    catchError((error: HttpErrorResponse) => {
      const currentToken = authService.getToken();
      if (error.status !== 401 || !currentToken?.refresh_token) {
        return throwError(() => error);
      }

      const refreshedToken$ =
        currentToken.token !== token.token
          ? of(currentToken)
          : authService.refreshToken(currentToken);

      return refreshedToken$.pipe(
        switchMap((refreshed) => next(authorizedRequest(refreshed.token)))
      );
    }),
    takeUntil(authService.authEvents$)
  );
};
